export default {
  "logoLink": "https://www.atfx.com/en",//修改该参数请在/static/lang.js也需修改
  "FCA_License_No": "FCA License No",//修改该参数请在/static/lang.js也需修改
  "headTtitle": "Open a Live Forex & CFD Trading Account | ATFX UK",//修改该参数请在/static/lang.js也需修改
  "topFixedBanner": "Spread bets and CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. The vast majority of retail client accounts lose money when trading CFDs. You should consider whether you can afford to take the high risk of losing your money.",//修改该参数请在/static/lang.js也需修改
  "topFixedBannerShort": "59.38% of retail investor accounts lose money when trading CFDs / Spread betting with this provider.",//修改该参数请在/static/lang.js也需修改
  "headDescription": "Open an ATFX forex and CFD live account with UK FCA regulated broker. Low spread, leverage 1:200, MT4 platform, 24/5 customer support. Sign up an account now!",
  "policyBarClose": 'The Firm has taken the decision to cease providing services to retail clients, with immediate effect. We are therefore unable to accept any applications.<br />Services to professional clients will not be impacted. For professional applications please contact <a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a>',
  "policyBar":'We use cookies to ensure you get the best experience on our website. By continuing to browse you accept our use of cookies. <a title="[Read more]" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blanck">[Read more]</a>',
  "policyBarButton":'Accept',
  "header": {
    "registration": "ACCOUNT OPENING",
    "personalDetails1": "Personal Details 1",
    "personalDetails2": "Personal Details 2",
    "financialDetails": "Financial Details",
    "Experience": "Experience",
    "Knowledge": "Knowledge",
    "Acknowledgements": "Acknowledgements",
    "previewPage": "Preview",
    "liveTrading": "LIVE TRADING"
  },
  footer:{//修改该参数请在/static/lang.js也需修改
    "copyright":"© 2020 ATFX.COM. All rights reserved.",
    "terms1":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf" target="_blank" rel="noopener">Privacy Policy</a>',
    "terms2":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blank" rel="noopener">Cookies Policy</a>',
    "terms3":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blank" rel="noopener">Terms and Conditions</a>',
    "Legal":"Legal: AT Global Markets (UK) Limited is authorised and regulated by the Financial Conduct Authority (FCA) in the United Kingdom. FCA registration number (760555). Registered Office: 1st Floor, 32 Cornhill, London EC3V 3SG,United Kingdom. Company No. 09827091",
    "riskWaring":'Spread bets and CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. <strong>59.38% of retail investor accounts lose money when trading CFDs / Spread betting with this provider. </strong>You should consider whether you understand how CFDs / Spread betting work and whether you can afford to take the high risk of losing your money. Please read the full risk disclosure on pages 42-45 of our <a title="Terms of Business" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blanck">Terms of Business</a>. <p>The commercialisation of services and the acquisition of clients can only be carried out in Spain by an authorised entity or through a tied agent.</p>',
    "otherInfo":"The information on this site is not directed at residents of the United States, Belgium or any particular country outside the UK and is not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation. "
  },
  "headerMsg": {
    "personalDetails1": "By submitting this information I confirm that I agree to the ATFX <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>Standard Terms of Business</a> and <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Privacy Policy</a> and may be contacted about my application.",
    "personalDetails2": "By submitting this information I confirm that I agree to the ATFX <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>Standard Terms of Business</a> and <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Privacy Policy</a> and may be contacted about my application.",
    "financialDetails": "As an FCA regulated firm we are obliged to assess whether our products are appropriate for you.The responses you provide will determine if we can provide you with our services.",
    "experience": "As an FCA regulated firm we are obliged to assess whether our products are appropriate for you.The responses you provide will determine if we can provide you with our services.",
    "knowledge": "As an FCA regulated firm we are obliged to assess whether our products are appropriate for you.The responses you provide will determine if we can provide you with our services.",
    "acknowledgements": "By completing this application, you confirm that you understand that margined FX and CFDs are leveraged products and pose a high risk to your invested capital. You further confirm that it is your responsibility to monitor your account."
  },
  "changeLanguage": "Change Language",
  "back": "Back",
  "next": "Next",
  "finish": "Submit",
  "personalDetails1": {
    "estimatedTime":"Estimated time to complete your registration is 5 minutes",
    "Gender": "Gender",
    "genderSelect": {
      "M": "Male",
      "F": "Female",
      "O": "Others"
    },
    "OtherGender": "Other Gender",
    "Title": "Title",
    "titleSelect": {
      "Mr": "Mr.",
      "Mrs": "Mrs",
      "Ms": "Ms",
      "Miss": "Miss",
      "Dr": "Dr",
      "Other": "Others"
    },
    "OtherTitle": "Other Title",
    "First_Name": "First Name",
    "Surname": "Surname",
    "Email": "E-mail",
    "Email_Confirm": "E-mail Confirm",
    "Lang": "E-mail Language",
    "emailLanguages": {
      "ENG": "English",
      "CHT": "Traditional Chinese",
      "CHS": "Simplified Chinese",
      "ARA": "Arabic",
      "ESP": "Spanish",
      "ITA": "Italian",
      "GER": "German",
      "PTG": "Portuguese"
    },
    "MT4_Currency": "Trading Account Currency",
    "MT4CurrencySelect": {
      "USD": "(USD) Dollar",
      "GBP": "(GBP) Pound",
      "EUR": "(EUR) Euro"
    },
    "Account_Type": "MT4 Account Type",
    "Account_TypeSelect": {
      "CFDs": "CFDs",
      "SpreadBetting":"Spread betting"
    },
    "Country": "Country of Residence",
    "countrySelect": {
      "USA": "United States of America",
      "HKG": "Hong Kong",
      "GBR": "United Kingdom",
      "CHN": "China",
      "TWN": "Taiwan, China",
      "ARE": "United Arab Emirates",
      "ALB": "Albania",
      "AND": "Andorra",
      "AIA": "Anguilla",
      "ATG": "Antigua and Barbuda",
      "ARG": "Argentina",
      "ARM": "Armenia",
      "ABW": "Aruba",
      "AUS": "Australia",
      "AUT": "Austria",
      "AZE": "Azerbaijan",
      "BHS": "Bahamas",
      "BHR": "Bahrain",
      "BGD": "Bangladesh",
      "BRB": "Barbados",
      "BLR": "Belarus",
      "BEL": "Belgium",
      "BLZ": "Belize",
      "BEN": "Benin",
      "BMU": "Bermuda",
      "BOL": "Bolivia",
      "BWA": "Botswana",
      "BVT": "Bouvet Island",
      "BRA": "Brazil",
      "BRN": "Brunei Darussalam",
      "BGR": "Bulgaria",
      "BFA": "Burkina Faso",
      "BDI": "Burundi",
      "KHM": "Cambodia",
      "CMR": "Cameroon",
      "CPV": "Cape Verde",
      "CYM": "Cayman Islands",
      "CAF": "Central African Republic",
      "TCD": "Chad",
      "CHL": "Chile",
      "CCK": "Cocos Islands",
      "COL": "Colombia",
      "COM": "Comoros",
      "COK": "Cook Islands",
      "CRI": "Costa Rica",
      "CIV": "Cote d'Ivoire",
      "HRV": "Croatia",
      "CUB": "Cuba",
      "CYP": "Cyprus",
      "CZE": "Czech Republic",
      "DNK": "Denmark",
      "DJI": "Djibouti",
      "DMA": "Dominica",
      "DOM": "Dominican Republic",
      "EGY": "Egypt",
      "SLV": "El Salvador",
      "ERI": "Eritrea",
      "EST": "Estonia",
      "ETH": "Ethiopia",
      "FJI": "Fiji",
      "FIN": "Finland",
      "FRA": "France",
      "PYF": "French Polynesia",
      "GAB": "Gabon",
      "GEO": "Georgia",
      "DEU": "Germany",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GRC": "Greece",
      "GRL": "Greenland",
      "GRD": "Grenada",
      "GLP": "Guadeloupe",
      "GTM": "Guatemala",
      "GIN": "Guinea",
      "GNB": "Guinea-Bissau",
      "HTI": "Haiti",
      "HMD": "Heard and McDonald Islands",
      "HND": "Honduras",
      "HUN": "Hungary",
      "ISL": "Iceland",
      "IND": "India",
      "IDN": "Indonesia",
      "IRL": "Ireland",
      "ISR": "Israel",
      "ITA": "Italy",
      "JAM": "Jamaica",
      "JPN": "Japan",
      "JOR": "Jordan",
      "KAZ": "Kazakhstan",
      "KEN": "Kenya",
      "KIR": "Kiribati",
      "KOR": "Republic of Korea",
      "KWT": "Kuwait",
      "KGZ": "Kyrgyzstan",
      "LVA": "Latvia",
      "LSO": "Lesotho",
      "LBR": "Liberia",
      "LBY": "Libya",
      "LIE": "Liechtenstein",
      "LTU": "Lithuania",
      "LUX": "Luxembourg",
      "MAC": "Macau",
      "MDG": "Madagascar",
      "MWI": "Malawi",
      "MYS": "Malaysia",
      "MDV": "Maldives",
      "MLI": "Mali",
      "MLT": "Malta",
      "MHL": "Marshall Islands",
      "MTQ": "Martinique",
      "MUS": "Mauritius",
      "MYT": "Mayotte",
      "MEX": "Mexico",
      "MDA": "Moldova",
      "MCO": "Monaco",
      "MNG": "Mongolia",
      "MNE": "Montenegro",
      "MSR": "Montserrat",
      "MAR": "Morocco",
      "MOZ": "Mozambique",
      "NAM": "Namibia",
      "NRU": "Nauru",
      "NLD": "Netherlands",
      "NCL": "New Caledonia",
      "NZL": "New Zealand",
      "NIC": "Nicaragua",
      "NER": "Niger",
      "NGA": "Nigeria",
      "NIU": "Niue",
      "NFK": "Norfolk Island",
      "NOR": "Norway",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PSE": "Palestine",
      "PRY": "Paraguay",
      "PER": "Peru",
      "PHL": "Philippines",
      "PCN": "Pitcairn",
      "POL": "Poland",
      "PRT": "Portugal",
      "QAT": "Qatar",
      "ROU": "Romania",
      "RUS": "Russia",
      "RWA": "Rwanda",
      "SHN": "Saint Helena",
      "KNA": "Saint Kitts and Nevis",
      "LCA": "Saint Lucia",
      "SPM": "Saint Pierre and Miquelon",
      "VCT": "Saint Vincent and the Grenadines",
      "WSM": "Samoa",
      "SMR": "San Marino",
      "STP": "Sao Tome and Principe",
      "SAU": "Saudi Arabia",
      "SEN": "Senegal",
      "SRB": "Serbia",
      "SYC": "Seychelles",
      "SLE": "Sierra Leone",
      "SGP": "Singapore",
      "SVK": "Slovakia",
      "SVN": "Slovenia",
      "ZAF": "South Africa",
      "ESP": "Spain",
      "SUR": "Suriname",
      "SJM": "Svalbard and Jan Mayen",
      "SWZ": "Swaziland",
      "SWE": "Sweden",
      "CHE": "Switzerland",
      "TJK": "Tajikistan",
      "TZA": "Tanzania",
      "THA": "Thailand",
      "TLS": "Timor-Leste",
      "TGO": "Togo",
      "TON": "Tonga",
      "TTO": "Trinidad and Tobago",
      "TUN": "Tunisia",
      "TUR": "Turkey",
      "TKM": "Turkmenistan",
      "TCA": "Turks and Caicos Islands",
      "TUV": "Tuvalu",
      "UKR": "Ukraine",
      "URY": "Uruguay",
      "UZB": "Uzbekistan",
      "VUT": "Vanuatu",
      "VAT": "Vatican",
      "VEN": "Venezuela",
      "VNM": "Vietnam",
      "WLF": "Wallis and Futuna",
      "ESH": "Western Sahara",
      "ZMB": "Zambia",
      "DZA": "Algeria",
      "AGO": "Angola",
      "BIH": "Bosnia-Herzegovina",
      "GMB": "Gambia",
      "GUY": "Guyana",
      "IRQ": "Iraq",
      "RKS": "Kosovo",
      "LBN": "Lebanon",
      "MKD": "Macedonia",
      "NPL": "Nepal",
      "PAN": "Panama",
      "PNG": "Papua New Guinea",
      "LKA": "Sri Lanka"
    }
  },
  "personalDetails2": {
    "Addr": "Address Line 1",
    "Addr2": "Address Line 2",
    "City": "Town / City",
    "Postcode": "Postcode",
    "Building_Name": "Building number/name",
    "Street": "Street",
    "Province": "Province",
    "birthDate": "Date of Birth",
    "birthYear": "Year",
    "birthMonth": "Month",
    "birthSecond": "Day",
    "Nationality": "Nationality",
    "isHavePass": "Do you have a passport",
    "PotSelect": {
      "havePot": "Yes",
      "noPot": "No"
    },
    "NAT_ID": "Passport Number",
    "Phone": "Mobile Phone",
    "countryPlace": "Country of tax residence",
    "TIN": "TIN(Taxpayer identification number)",
    "Doc_Type": "ID Type",
    "idTypeSelect": {
      "POT": "Passport",
      "IDC": "ID Card",
      "DRI": "Driver License"
    },
    "Doc_No": "ID No",
    "bankCardType": "Bank Card Type",
    "bankCardTypeSelect": {
      "DR": "Debit Card",
      "CR": "Credit Card"
    },
    "Addr_Country": "Address Country",
    "Bank_Card_No": "Bank Number",
    "bankCardNoConfirm": "Bank number confirmation",
    "Bank": "Bank",
    "bankSelect": {
      "ICBK": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA",
      "ABOC": "AGRICULTURAL BANK OF CHINA",
      "PCBC": "CHINA CONSTRUCTION BANK CORPORATION",
      "BKCH": "BANK OF CHINA LIMITED",
      "CMBC": "CHINA MERCHANTS BANK",
      "COMM": "BANK OF COMMUNICATIONS",
      "MSBC": "CHINA MINSHENG BANKING CORPORATION, LIMITED",
      "EVER": "CHINA EVERBRIGHT BANK",
      "SPDB": "SHANGHAI PUDONG DEVELOPMENT BANK",
      "FJIB": "INDUSTRIAL BANK",
      "CIBK": "CITIC BANK CORPORATION LIMITED",
      "PSBC": "POSTAL SAVINGS BANK OF CHINA",
      "SZCB": "SHENZHEN DEVELOPMENT BANK CO., LTD",
      "GDBK": "CHINA GUANGFA BANK",
      "BOSH": "BANK OF SHANGHAI",
      "BJCN": "BANK OF BEIJING",
      "HXBK": "HUA XIA BANK",
      "other": "OTHER"
    },
    "OtherBank": "Other banks",
    "Beneficiary_Name": "Beneficiary Name",
    "SWIFT_Code": "Bank Swift Code",
    "Branch_Name": "Branch Name",
    "Bank_Addr": "Branch Address",
    "Branch_Province": "Branch Province",
    "Branch_City": "Branch City",
    "bankCardImg": "Bank Card Img",
    "IBAN_Code": "IBAN",
    "docFrontImgword": "ID Image (Front)",
    "docBackImgword": "ID Image (Back)",
    "addressUpload": "Proof of Address",
    "addressUpload2": "Proof of Address 2",
    "addressUploadTxt1": "available proof: within 3 months of the electricity / gas bill list / bank statements / residence permit / license / ID / hukou (if the applicant is not the head of household, together with the need to merge into the pictures of the 1 page submission);",
    "addressUploadTxt2": "address proof shall not be the same as identity certificate.",
    "docImgword1": "document attachment 1",
    "docImgword2": "document attachment 2",
    "docImgword3": "document attachment 3",
    "docImgword4": "document attachment 4",
    "docImgword5": "document attachment 5",
    "fileUpload": {
      "imgtUpload": "upload",
      "uploadFileArr": [{
        "labelTxt": "ID Image1",
        "ValidateNull": "Please Select",
        "sizeLimit": "ID Image1 can't exceed 5MB!"
      }, {
        "labelTxt": "ID Image2",
        "ValidateNull": "Please Select",
        "sizeLimit": "ID Image2 can't exceed 5MB!"
      }, {
        "labelTxt": "Proof of Address",
        "ValidateNull": "Please Select",
        "sizeLimit": "Proof of AddressID can't exceed 5MB!"
      }, {
        "labelTxt": "Proof of Address 2",
        "ValidateNull": "Please Select",
        "sizeLimit": "Proof of AddressID can't exceed 5MB!"
      }, {
        "labelTxt": "Other Files",
        "ValidateNull": "Please Select",
        "sizeLimit": "Other Files can't exceed 5MB!"
      }],
      "addressUploadHtml": {
        "sizeLimit":"The file size cannot exceed 5MB",
        "upload_your_documents":"Upload Your Identity Documents",
        "documents_not_ready":"DOCUMENTS NOT READY?",
        "noe": "*Applicants must provide ID image and proof of address to verify their identity. We do not accept: mobile phone bills, credit card bills, or any mobile services bills; insurance receipts; invoice for purchased good/services.",
        "noe2":"You can still complete your application if you don't have the required documents right now. <br/><b>However, you will not be able to trade until we receive the required documents.<b/>",
        "header1": "Proof of Identity (Minimum requirement: $Logic)",
        "list1": "We require colour copies of the original government issued ID/passport document. For ID we require front and back sides of card.",
        "list1_new":"We require a clear and colour copy of the original passport, with all four corners visible.",
        "header2": "Proof of Address (Any $Logic of the following options)",
        "list2": "<ol class='list-style-position:inside'><li>Utility bill (water/electricity/gas) – issued in the past 3 months,</li><li>Bank Statement issued in the past 3 months,</li><li>We can accept residence books/property books including Chinese Hukou – but are subject to review.</li><li>A current rental agreement, and a supporting utility bill (gas/water/electricity), paid in previous 3 months, has to be provided.</li><li>A recent tax bill, if only issued in the past 6 months.</li><li>A landline Phone bill, issued in the past 3 month.</li></ol>",
        "strongTxt":"<strong>As part of our regulatory requirements, we may require additional documents in regards to your application.</strong>"
      }
    },
    "isHaveCitizen": "Are you a Citizen of the United States of America?",
    "CitizenSelect": {
      "Y": "Yes",
      "N": "No"
    },
    "citizen_Tip":"Unfortunately, we cannot open an account for US citizens",
    "isDualCitizenship": "Are you a tax resident anywhere other than the country in which you reside?",
    "DualCitizenshipSelect": {
      "Y": "Yes",
      "N": "No"
    },
    "Dual_Nationality":"Country",

    "IS_Politically_Person": "Are you a Politically Exposed Person?",
    "IS_Politically_Exposed":'Politically exposed person” means a natural person who is or who has been entrusted with prominent public functions in the Republic or in another country,an immediate close relative of such person as well as a person known to be a close associate of such person:<br/>Provided that, for the purpose of the present definition, ‘prominent public function’ means any of the following public functions:<br/>(a) heads of State, heads of government, ministers and deputy or assistant ministers;<br/>(b) members of parliament or of similar legislative bodies;<br/>(c) members of the governing bodies of political parties;<br/>(d) members of supreme courts, of constitutional courts or of other high-level judicial bodies, the decisions of which are not subject to further appeal, except in exceptional circumstances;<br/>(e) members of courts of auditors or of the boards of central banks;<br/>(f) ambassadors, chargés d\'affaires and high-ranking officers in the armed forces;<br/>(g) members of the administrative, management or supervisory bodies of State-owned enterprises;<br/>(h) directors, deputy directors and members of the board or equivalent function of an international organisation;<br/>(i) mayor: Provided further that no public function referred to in points (a) to<br/>(i) shall be understood as covering middle-ranking or more junior officials;<br/>Provided furthermore that ‘close relatives of a politically exposed person’ includes the following:<br/>(a) the spouse, or a person considered to be equivalent to a spouse, of a politically exposed person;<br/>(b) the children and their spouses, or persons considered to be equivalent to a spouse, of a politically exposed person;<br/>(c) the parents of a politically exposed person; Provided even furthermore that ‘persons known to be close<br/>associates of a politically exposed person’ means natural person:<br/>(a) who is known to have joint beneficial ownership of legal entities or legal arrangements, or any other close business relations, with a politically exposed person;<br/>(b) who has sole beneficial ownership of a legal entity or legal arrangement which is known to have been set up for the de facto benefit of a politically exposed person.<br/>',
    "IS_Politically_Person_Select": {
      "Y": "Yes",
      "N": "No"
    },
  },
  "financialDetails": {
    "Emp_Status": "Employment Status",
    "employmentStatusSelect": {
      "b": "Employed",
      "a": "Self-employed",
      "c": "Student",
      "e": "Retired",
      "d": "Unemployed"
    },
    "Freelance_OwnACompany": "Freelance / Own a Company",
    "Freelance_OwnACompany_select": {
      "0": "Freelance",
      "1": "Own a Company"
    },
    "Position": "Position",
    "FD_Position_select": {
      "0": "C Grade manager e.g. CEO, CFO, CIO",
      "1": "Senior Manager",
      "2": "General / Middle Manager",
      "3": "Supervisor",
      "4": "Clerk",
      "5": "Staff",
      "6": "Junior",
      "7": "Others(Please specify)"
    },
    "Employer": "Business name",
    "Biz_Nature": "Nature of business",
    "financialRegulator": "Is your employer authorised by the FCA or another financial regulator?",
    "financialRegulatorSelect": {
      "Y": "Yes",
      "N": "No"
    },
    "Industry_Sector": "Industry / Sector",
    "Industry_Sector_select": {
      "0": "Accounting",
      "1": "Advertising/Media",
      "2": "Computer/Internet/Communication/Electronics",
      "3": "Education/Training",
      "4": "Energy / raw materials",
      "5": "Financial Services (Finance/Banking/Insurance)",
      "6": "Government/Nonprofit",
      "7": "Human Resources",
      "8": "Legal",
      "9": "Marketing",
      "10": "Logistics/Transportation",
      "11": "Pharmaceutical/Medical",
      "12": "Professional Services",
      "13": "Real Estate / Construction",
      "14": "Service Industry",
      "15": "Trade / Consumer / Manufacturing / Operations",
      "16": "Others (Please specify)"
    },
    "Annual_Income": "Annual Income",
    "Annual_Income_word":"This includes all earned income including wages, pensions, interest, dividends, rental income etc.",
    "Total_Saving_Investments": "Total Saving & Investments",
    "Total_Saving_word": "This includes all bank or brokerage accounts, certificates, bonds, money market investments etc.",
    "Total_Saving_Investments_select": {
      "0": "Over US$500,000",
      "1": "US$200,000-US$499,999",
      "2": "US$100,000-US$199,999",
      "3": "US$50,000-US$99,999",
      "4": "US$25,000-US$49,999",
      "5": "US$10,000-US$24,999",
      "6": "US$2,000-US$9,999",
      "7": "Less than US$2,000"
    },
    "liquidNetWorth": "Liquid Net Worth (excluding private residence)",
    "financialPortfolio": "Value of your financial portfolio",
    "annualIncomeSelect": {
      "0": "Over US$200,000",
      "1": "US$100,000-US$199,999",
      "2": "US$50,000-US$99,999",
      "3": "US$25,000-US$49,999",
      "4": "US$10,000-US$24,999",
      "5": "Less than US$10,000"
    },
    "fundsSource": "Source of these funds",
    "fundsSourceSelect": {
      "0": "None",
      "1": "Family and Partner income",
      "2": "Government Benefit",
      "3": "Loan/Credit",
      "4": "Pension",
      "5": "Property Income",
      "6": "Others (Please specify)"
    },
    "Funds_Source": "Other source of income",
    "Intend_Deposit": "How much do you intend to deposit?",
    "intendDepositSelect": {
      "0": "Over US$100,000",
      "1": "US$80,000 – US$99,999",
      "2": "US$50,000 – US$79,999",
      "3": "US$25,000 – US$49,999",
      "4": "US$10,000 – US$24,999",
      "5": "Less than US$10,000"
    },
    "Other_Industry_Sector": "Other Industry / Sector",
    "Other_Position": "Other Position",
    "Other_Biz_Nature": "Other Nature of business",
    "Other_Funds_Source": "Other source of income",

    "Afford_To_Lose_Error":"CFDs are high risk products, you should only trade with money you can afford to lose.",
    "Afford_To_Lose":"Can you afford to lose the funds you plan to invest?",
    "Afford_To_Lose_Select": {
      "Y": "Yes",
      "N": "No"
    },
    "Open_Trading_Account":"Why do you want to open a trading account with ATFX?",
    "Open_Trading_Account_Select": {
      "0": "Short – medium term speculation on financial markets",
      "1": "Short – medium term hedging against exposures on existing investments",
      "2": "Short - medium term speculation on financial markets and hedging against exposures on existing investments "
    },
    "ATFX_Client_Pro":"ATFX has deemed its products suitable only for clients with the above objectives, please do not proceed with this application if your objectives differ from those listed above.",
    "Annual_Income_Total":"Please provide your actual annual income",
    "Saving_Investments_Money":"Please provide your actual total saving & investments",
  },
  "Experience": {
    "experienceLabel": "Over the past three years, to what extent have you traded the following financial instruments where you have made your own trading decisions?",
    "Futures_Options": "Futures / Options",
    "Futures_Options_select": {
      "0": "On more than 40 occasions",
      "1": "On 15 to 40 occasions",
      "2": "On 1 to 15 occasions",
      "3": "Never"
    },
    "CFDs_Spread_Bets": "CFDs, Foreign Exchange Derivatives or Spread Bets",
    "CFDs_Spread_Bets_select": {
      "0": "On more than 40 occasions",
      "1": "On 15 to 40 occasions",
      "2": "On 1 to 15 occasions",
      "3": "Never"
    },
    "Derivative_Trade_over2": "In the last twelve months, have you made at least two trades per quarter in Spot FX / CFDs / Options / Futures or Spread Bets where you made your own trading decisions?",
    "Derivative_Trade_over2_select": {
      "b": "Yes",
      "a": "No"
    },
    "Derivative_Trade_over40": "During the last three years, have you made forty trades in one twelve-month period in Spot FX / CFDs / Options / Futures or Spread Bets?",
    "Derivative_Trade_over40_select": {
      "b": "Yes",
      "a": "No"
    },

    "Average_Annual_Investment":"What was the average yearly volume of invested amounts of your past transactions in the financial products you selected above?",
    "Average_Annual_Investment_select": {
      "0": "I have never invested",
      "1": "Less than US$500 ",
      "2": "Between US$500 to US$2,500",
      "3": "Between US$2,500 to US$10,000",
      "4": "Over US$10,000"
    },

    "Average_Leverage_Level":"What was the average level of leverage you used for trading in the financial products you selected above?",
    "Average_Leverage_Level_select": {
      "0": "I have never used leverage",
      "1": "Up to 1:10",
      "2": "Between 1:10 - 1:25",
      "3": "Between 1:25 - 1:50",
      "4": "Between 1:50 - 1:100",
      "5": "More than 1:100"
    },

  },
  "Knowledge": {
    "DT_Work_Experience": "Have you ever worked in a position which required knowledge of leveraged derivative trading?",
    "DT_Work_Experience_select": {
      "txt1": "Yes",
      "txt2": "No",
      "subTxt1": "I have at least 3 years’ work experience",
      "subTxt2": "I have less than 3 years’ work experience or at least one years’ experience investing on my own behalf."
    },
    "DT_Qualification": "Do you have a qualification which has given you an understanding of leveraged derivative trading?",
    "DT_Qualification_select": {
      "txt1": "Yes",
      "txt2": "No",
      "subTxt1": "I hold a professional qualification or degree such as the CFA, MBA, BSC or MA",
      "subTxt2": "I hold a qualification or degree in finance, economics, accounting or a similar field"
    },
    "K_Sell_Position": "If you sell 1 lot of gold (XAUUSD) at a price of 1200 and the market moves to a price of 1300, would you make or lose money?",
    "K_Sell_Position_b": "If you sell 1 lot of gold XAUUSD.sb at a price of 1200 and the market moves to a price of 1300, would you make or lose money?",
    "K_Sell_Position_select": {
      "0": "Lose",
      "1": "Make"
    },
    "Closing_Order": "In order to prevent your account from losing more than your predetermined amount. Would you limit your loss by placing a stop loss or take profit?",
    "Closing_Order_select": {
      "0": "Stop Loss",
      "1": "Take Profit"
    },
    "K_Profit_Change": "Do you understand that the greater the leverage results in higher risk to your capital when you trade leveraged CFD products?",
    "K_Profit_Change_b": "Do you understand that the greater the leverage results in higher risk to your capital when you trade leveraged CFDs/Spread Betting products?",
    "K_Profit_Change_select": {
      "0": "Understand",
      "1": "Don't Understand"
    },
    "K_Margin": "What would be the required margin for 1 lot (100,000) USD/JPY, if your margin is 1:20?",
    "K_Margin_select": {
      "0": "USD 5,000",
      "1": "USD 50,000",
      "2": "USD 100,000"
    }
  },
  "Acknowledgements": {
    "A1": "I confirm that the information provided to you is accurate and complete, and undertake to notify you if there are any changes to this information.",
    "A2": "I have read, understood and agree to be bound by the AT Global Markets Customer Agreement which has been provided to me.",
    "A2_txt": "the AT Global Markets Customer Agreement",
    "A2_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>the AT Global Markets Customer Agreement</a>",
    "A3": "I have read, understood and agree to the AT Global Markets Risk Disclosure Statement which has been provided to me",
    "A3_txt": "the AT Global Markets Risk Disclosure Statement",
    "A3_link": "<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>the AT Global Markets Risk Disclosure Statement</a>",
    "A4": "I  have read, understood and agree to the AT Global Markets Order Execution Policy and Conflicts Policy which have been provided to me.",
    "A4_txt": "the AT Global Markets Order Execution Policy and Conflicts Policy",
    "A4_link": "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>the AT Global Markets Order Execution Policy</a> and <a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-en.pdf' target='_blank'>Conflicts Policy</a>",
    "header": "By completing this application, you confirm that you understand that margined FX and CFDs are leveraged products and pose a high risk to your invested capital. You further confirm that it is your responsibility to monitor your account.",
    "age": "You confirm that you are aged 18 or over;",
    "message": "The information provided in this application is true and correct, you undertake to notify us if there are any changes to this information;",
    "receive": {
      "text": "You have read, understood and agree to our",
      "list": [
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf' target='_blank'>Terms of Business and  Risk Warning</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>Order Execution Policy</a>",
        "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Privacy Policy</a>",
        // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-en.pdf' target='_blank'>Introducer Broker Disclosure</a>",
        "<a href='https://www.atfx.com/en/legal' target='_blank'>Key Information Document</a>"
      ]
    },
    "A_select": {
      "text": "I have read, understand and agree to all terms.",
      "Y": "I have read, understand and agree to all terms."
    },
    "checkboxTxt_A1": "I have read, understood and agree to all terms and conditions.",
    "checkboxTxt_A2": "I understand that CFDs are leveraged products and their performance may be volatile.",
    "checkboxTxt_A3": "I understand that it is my responsibility to monitor and manage my account.",
    "checkboxTxt_A4": "I understand that when trading leveraged products it is possible to lose more than my initial investment.",
    "Marketing_Email_Preference": "I agree to receive information from ATFX which may contain marketing materials.",
    "Marketing_automatically": "I understand that I can opt out of receiving marketing communications immediately by contacting the <a href='https://www.atfx.com/en/about-us/contact-us' target='_blank'>Customer Service team</a>.",
    "Marketing_Email_Preference_select": {
      "Y": "Yes",
      "N": "No"
    },
    "Hear_ATFX": "How did you hear about ATFX?",
    "OtherHearATFX": "Other ways",
    "hearATFXSelect": {
      "Recommendation": "Recommendation",
      "SearchEngine": "Search Engine",
      "MediaAdvertising": "Media Advertising",
      "Partnership": "Partnership",
      "Other": "Others"
    },
    "Parent_IB_Code": "Referrer Code",
    "Rec_Type": "Referrer Type",
    "recTypeSelect": {
      "AA1": "AA1",
      "AA2": "AA2",
      "AA3": "AA3",
      "A01": "A01",
      "A02": "A02",
      "A03": "A03",
      "A00": "A00",
      "NAN": "No Referrer"
    },
    "recGroup": "Referrer Group",
    "recGroupSelect": {
      "A": "A",
      "AA": "AA"
    }
  },
  "customErrMsg": {
    "fieldIsRequired": {
      "Gender": "Please Select",
      "OtherGender": "Other Gender",
      "Title": "Please Select",
      "OtherTitle": "Other Title",
      "First_Name": "First Name",
      "Surname": "Surname",
      "Email": "Email Address",
      "Email_Confirm": "Comfirm Email",
      "Lang": "Please Select",
      "Country": "Please Select",
      "MT4_Currency": "Please Select",
      "Account_Type": "Please Select",
      "Addr": "Address",
      "Addr2": "Address Line 2",
      "City": "City",
      "Postcode": "Postcode",
      "Building_Name": "Building number/name",
      "Street": "Street",
      "Province": "Province",
      "Birth_Date_Year": "Date of Birth",
      "Birth_Date_Month": "Date of Birth",
      "Birth_Date_Day": "Date of Birth",
      "Nationality": "Nationality",
      "isHavePass": "Please Select",
      "NAT_ID": "Passport Number",
      "Phone": "Phone",
      "Doc_Type": "Please Select",
      "Doc_No": "ID No.",
      "Addr_Country": "Please Select",
      "Bank_Card_No": "Bank Number",
      "Bank": "Please Select",
      "OtherBank": "Other banks",
      "Beneficiary_Name": "Beneficiary Name",
      "Branch_Name": "Branch Name",
      "Bank_Addr": "Branch Address",
      "Branch_Province": "Branch Province",
      "Branch_City": "Branch City",
      "FD_Emp_Status": "Please select",
      "FD_Position": "Position",
      "FD_Employer": "Company Name",
      "FD_Biz_Nature": "Please enter the business attributes",
      "FD_FCA_AUTH": "Please select",
      "FD_Annual_Income": "Please select",
      "FD_Liquid_Net_Worth": "Please select",
      "FD_Portfolio_Value": "Please select",
      "FD_Funds_Source": "Please select",
      "FD_Funds_Other": "Please select",
      "E_Forex_Exp": "Please select",
      "E_Forex_Trade_No": "Please select",
      "E_Derivative_Exp": "Please select",
      "E_Derivative_Trade_No": "Please select",
      "E_Equity_Exp": "Please select",
      "E_Equity_Trade_No": "Please select",
      "K_A": "Please Select",
      "K_A_Detail": "Details",
      "K_B": "Please Select",
      "K_B_Detail": "Details",
      "K_C": "Please Select",
      "K_C_Detail": "Details",
      "K_D": "Please Select",
      "K_E": "Please Select",
      "K_F": "Please Select",
      "K_G": "Please Select",
      "K_H": "Please Select",
      "A1": "Please Select",
      "A2": "Please Select",
      "A3": "Please Select",
      "A4": "Please Select",
      "checkList": "Please Select",
      "Emp_Status": "Please Select",
      "Freelance_OwnACompany": "Please Select",
      "Industry_Sector": "Please Select",
      "Position": "Please Select",
      "Employer": "Company Name",
      "Biz_Nature": "Please enter the business attributes",
      "Annual_Income": "Please Select",
      "Total_Saving_Investments": "Please Select",
      "Funds_Source": "Please Select",
      "Intend_Deposit": "Please Select",
      "Other_Industry_Sector": "Other Industry / Sector",
      "Other_Position": "Other Position",
      "Other_Biz_Nature": "Other Nature of business",
      "Other_Funds_Source": "Other source of income",
      "Futures_Options": "Please Select",
      "CFDs_Spread_Bets": "Please Select",
      "Derivative_Trade_over2": "Please Select",
      "Derivative_Trade_over40": "Please Select",
      "DT_Work_Experience": "Please Select",
      "DT_Qualification": "Please Select",
      "K_Sell_Position": "Please Select",
      "Closing_Order": "Please Select",
      "K_Profit_Change": "Please Select",
      "K_Margin": "Please Select",
      "IBAN_Code": "IBAN",
      "Hear_ATFX": "Please Select",
      "OtherHearATFX": "Please Enter",
      "Rec_Type": "Please Select",
      "Parent_IB_Code": "Referrer Code",
      "isHaveCitizen":"Please Select",
      "isDualCitizenship":"Please Select",
      "Dual_Nationality":"Please Select",
      "Afford_To_Lose":"Please Select",
      "Open_Trading_Account":"Please Select",
      "Annual_Income_Total":"Please Enter",
      "Saving_Investments_Money":"Please Enter",
      "IS_Politically_Person":"Please Select"



    }
  },
  "errors": {
    "fieldIsRequired": "Email Address",
    "invalidFormat": "Invalid format!",
    "numberTooSmall": "The number is too small! Minimum: {0}",
    "numberTooBig": "The number is too big! Maximum: {0}",
    "invalidNumber": "Invalid number",
    "textTooSmall": "The length of text is too small! Current: {0}, Minimum: {1}",
    "textTooBig": "The length of text is too big! Current: {0}, Maximum: {1}",
    "thisNotText": "This is not a text!",
    "thisNotArray": "This is not an array!",
    "selectMinItems": "Select minimum {0} items!",
    "selectMaxItems": "Select maximum {0} items!",
    "invalidDate": "Invalid date!",
    "dateIsEarly": "The date is too early! Current: {0}, Minimum: {1}",
    "dateIsLate": "The date is too late! Current: {0}, Maximum: {1}",
    "invalidEmail": "Email Address is not available!",
    "invalidURL": "Invalid URL!",
    "invalidCard": "Invalid card format!",
    "invalidCardNumber": "Invalid card number!",
    "invalidTextContainNumber": "Invalid text! Cannot contains numbers or special characters",
    "invalidTextContainSpec": "Invalid text! Cannot contains special characters",
    "incorrectComfirm": "The two input is inconsistent",
    "invalidBirthDate": "Accepting application of aged 18-69 only",
    "invalidParentClnID": "please enter a number less than 12 digits!",
    "docImgFrontSizeLimit": "ID Image(front) can't exceed 2MB",
    "docImgBackSizeLimit": "ID Image(back) can't exceed 2MB！",
    "imgSizeLimit": "Proof of AddressID Image can't exceed 2MB.",
    "bankCardNoTopTwo": "The first two digits of the bank card are out of line",
    "bankCardNoLnegth": "Please enter a number of 16-19",
    "dayErrors1": "The year is a leap year, and there is no day",
    "dayErrors2": "his year for the year, the day does not exist",
    "dayErrors3": "The day does not exist this month",
    "emailError": "Email Address is not available",
    "DocTypeNoError": "ID No.is illegal",
    "DocFrontImg": "Please upload ID image(front)",
    "DocBackImg": "Please upload ID image(back)",
    "ProofofAddress": "Please upload proof of address",
    "Doc_No": "Please enter ID No",
    "Phone": "Phone",
    "Bank_Card_No": "Bank Number",
    "Birth_Date_Second": "Date of Birth",
    "phoneError": "Phone Format Incorrect",
    "bankNumError": "Bank Number Format Incorrect",
    "numType": "please enter number",
    "bankCodeError": "Bank IBAN Code Format Incorrect"
  },
  "messages": {
    "fieldsWillBeReset": "All input will be reset, please confirm",
    "completeTip1": "Please check your Email. Thank you.",
    "completeTip2": "Completed! Thank you.",
    "noCompleteTip": "Sorry, your input information is incorrect and the above operation failed",
    "emailAndDocInvalid": "Email Address has been used",
    "phoneAndDocInvalid": "Phone Number has been used",
    "IBCodeInvalid": "Referrer Code Incorrect",
    "invalidBankCardNo": "The bank card number is incorrect. Please check it before submitting it",
    "beneficiaryName": "Please use Account Name left with the Bank, third party is not allowed",
    "employerName": "We will not contact your employer",
    "errors": "Network errors",
    "unSelect": "Please Select",
    "selectEmpStatusTip": "Your employment status is showing you are Retired/Student/Unemployed. Trading Foreign Exchange (Forex) and Contracts for Differences (CFDs) is highly speculative and carries a high level of risk to your capital.</div><div style='padding-top:10px;'>To protect your immediate interests, we will review your suitability for the products we offer based on the supporting documents you provide confirming the savings/Inheritance balance mentioned within your application.</div>"
  },
  "ModalMsg": {
    "showModal": {
      "content": "Based on the information you provided on your AT Global Markets Limited (UK) Limited client account application, it is necessary for us to inform you that trading in CFDs and leveraged forex may not be appropriate for you. Leveraged trading carries a high degree of risk to your capital. The Company provides an execution-‐‐only service to its clients and you will need to rely upon your own skill and judgement when trading these markets. <br/><br/><b>Please note: AT Global Markets (UK) Limited oﬀers demo accounts where you can practice trading against realistic market prices and the Company would encourage you to try this before trading with real money.</b><br/><br/>If you still wish to open a client account with AT Global Markets (UK) Limited, please conﬁrm this by accepting the statement below.",
      "checkboxTxt":"I understand that trading in CFDs and leveraged forex trading carries a high degree of risk to my capital. I am able to assess the risks involved and wish to continue with my application to open an account.","errorsTxt": "Please tick the box",
      "btn": "Confirm"
    },
    "showAlert": {
      "title": "tip:",
      "submitBtnTxt": "confirm",
      "cancleBtnTxt": "cancel",
      "confirmBtnTxt": "confirm"
    }
  },
  "ratesModalMsg": {
    "p3_1": "WARNING - MARGIN RATE CHANGES FOR ALL RETAIL TRADERS",
    "p3_2": "Dear Applicant,",
    "p3_2_1": "",
    "p3_3": "Please note, due to the European Securities and Markets Authority (ESMA) changes for Retail Traders, all new ATFX clients from the 2nd July will be using the new Margin Rates.",
    "p3_4": "The changes include a cap on the amount of leverage that can be offered to retail traders.",
    "p4_1": "Major FX: Currency pairs containing any two of the following: USD, EUR, JPY, GBP, CAD, CHF - 3.33% (Leverage 30:1)",
    "p4_2": "Minor FX:  All other currency pairs - 5% (Leverage 20:1)",
    "p4_3": "Major indices: UK100, FRA40, ESP35, US30, SPX500, NAS100, JP225, AUS200 5% (Leverage 20:1)",
    "p4_4": "Gold: 5% (Leverage 20:1)",
    "p4_5": "Commodities: 10% (Leverage 10:1)",
    "p5_1": "Negative balance protection",
    "p5_2": "ESMA has introduced a new rule to ensure that all Retail Traders can never lose more than the money available on their account. If your balance does go negative, then ATFX will be obligated to bring your balance back to zero – at no cost to you, the client.",
    "p5_3": "50% margin close-out rule.",
    "p5_4": "ATFX already offers the 50% Margin Close out rule to all clients.",
    "p5_5": "If you wish to finalise your application and open an ATFX Retail Account please tick the below.",
    "p5_6": "I acknowledge and agree to the new terms for Retail Clients",
    "p6_2": "Please Agree ",
    "btnText": "SUBMIT"
  },
  "verifyMsg": {
    "email_exist": "This email address has already been used, please use an alternative email address.",
    "phone_exist": "This phone number has already been used, please use an alternative phone number.",
    "phoneAndemail_exist": "The phone number and email address have already been used, please use alternatives phone number and email address."
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js